import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GroupsService } from '../../../../services/groups/groups.service';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { GroupInterface } from '../../../../interfaces/groups/group.interface';
import { MarketingCampaignsService } from '../../../../services/marketing-campaigns/marketing-campaigns.service';
import { MatSnackBar } from '@angular/material/snack-bar';


export type MarketingCampaignCreateDependencies = {
  groups: GroupInterface[]
};

export type MarketingCampaignCreateResultSave = {
  save: true,
  newCampaign: any
};

export type MarketingCampaignCreateResultCancel = {
  save: false
};

export type MarketingCampaignCreateResult = MarketingCampaignCreateResultSave | MarketingCampaignCreateResultCancel;

export function atLeastOneChecked(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const value = control.value;
    return value.some((v: boolean) => v) ? null : { atLeastOne: true };
  };
}

@Component({
  selector: 'app-marketing-campaign-create',
  templateUrl: './marketing-campaign-create.component.html',
  styleUrls: ['./marketing-campaign-create.component.scss']
})
export class MarketingCampaignCreateComponent {

  protected form: FormGroup | undefined;
  protected groups: GroupInterface[] | undefined;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<MarketingCampaignCreateResult>,
    private marketingCampaignsService: MarketingCampaignsService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: MarketingCampaignCreateDependencies) {
    this.groups = data.groups;
    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
      description: new FormControl('', Validators.required),
      channel: new FormControl('email'),
      groups: this.fb.array(data.groups.map(() => new FormControl(false)), atLeastOneChecked()),
      data: new FormGroup({
        body: new FormControl(''),
        title: new FormControl(''),
        footer: new FormControl(''),
        header: new FormControl(''),
        subject: new FormControl('')
      })
    });
    this.dialogRef.backdropClick().subscribe(() => {
      this.dialogRef.close({ save: false });
    });
  }

  close(): void {
    this.dialogRef.close({ save: false });
  }

  async save(): Promise<void> {
    const rawData = this.form?.getRawValue();
    const selectedGroupIds = this.groups?.filter((_, i) => rawData.groups[i]).map(g => g.id) || [];
    const campaign = { ...rawData, groupIds: selectedGroupIds };
    try {
      await this.marketingCampaignsService.create(campaign);
      this.dialogRef.close({ save: true, newCampaign: rawData });
    } catch (error) {
      this.snackBar.open('Error while creating a Campaign. Try again in a few minutes.');
    }

  }
}
